/* eslint-disable react/no-danger */
import React, { PureComponent } from 'react';
import { routerShape } from 'react-router';
import scrollToComponent from 'react-scroll-to-component-ssr';
import PropTypes from 'prop-types';
import { JsonLd } from 'react-schemaorg';
import map from 'lodash/map';
import get from 'lodash/get';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import noScroll from 'helpers/noScroll';
import formatDate from 'helpers/formatDate';
import absoluteUrl from 'helpers/absoluteUrl';
import { emit } from 'helpers/global-events';
import simpleStore from 'helpers/simpleStore';
import beautifyNumber from 'helpers/beautifyNumber';
import { UserProp } from 'auth';
import Perms from 'auth/perms';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import Complaint from 'subsys/complaint';
import sensor from 'components/sensor';
import Button from 'components/button';
// import Share from 'components/share';
import { Thumb } from 'components/image';
import Row, { Col } from 'components/row';
import DropDown from 'components/drop-down';
import Icon, { iconTypes } from 'components/icon';
import Notification from 'components/notification';
import { FullScreenSlider } from 'components/image';
import ClipboardCopy from 'components/clipboard-copy';
import { ModalButton, Header, Content } from 'components/modal';
import Link from 'components/link';
import SlickSlider from 'components/slick-slider';
import Image from 'components/image';

import { getImages } from 'src-sites/domik/section-project/get-images';

import CardInfo from './card-info';
import AddForumNick from './add-forum-nick';
import ForumTopicAdd from './forum-topic-add';
import PostControl from './admin/post-control';
import ReplyPostButton from './reply-post-button';
import getHeaderHeight from './get-header-height';
import RemoveThemeContent from './admin/panel/remove-theme-content';
import ApprovePost from '../common/admin/panel/approve-post';
import { gotoPostById } from './render-common';

import translates from '../forum-i18n';

// import 'styles/forum/section-forum/_editing.scss'; // TODO: править вёрстку
// import 'styles/forum/section-forum/_object-list.scss'; // TODO: править вёрстку
import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';
import 'styles/forum/subsys/card-info/_card-info.scss';
import 'styles/forum/common/_post-list.scss';

import linksForum from 'src-sites/forum/links';

const bemClassesPosts = new Bem('postList');
const bemClassesCardInfo = new Bem('cardInfo');
const bemClassesPostsUserInfo = new Bem('postUserInfo');
const bemClassesBtn = new Bem('btn');
const bemClassesDD = new Bem('dropdown');
const bemClassesDDList = new Bem('dropDownList');
const bemClassesAdminPane = new Bem('adminPanelForum');
const classesBemForm = new Bem('modalContentAdmin');

// Show posts data.
@apiDecorator
@sensor
@I18nHoc(translates())
export default class Posts extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    router: routerShape,
    params: PropTypes.shape({}),
    data: PropTypes.shape({
      post_id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ])
    }),
    object: PropTypes.shape({}),
    userStatus: PropTypes.shape({
      forum_type: PropTypes.string,
      allRules: PropTypes.bool,
      clubUserStatus: PropTypes.bool
    }),
    auth: UserProp,
    actionDoLogin: PropTypes.func,
    checkPermission: PropTypes.func,
    onHandleSelectPost: PropTypes.func,

    // Selected posts by Admin via checkboxes
    selectedPosts: PropTypes.arrayOf(PropTypes.shape({})),

    // Delete post method
    onHandleDeletePost: PropTypes.func,

    onPostSubmit: PropTypes.func,

    // From search page
    search: PropTypes.bool,

    breadCrumbs: PropTypes.bool,

    // Администрирование жалоб
    complaintAdministration: PropTypes.bool,

    // Запрет постить новым пользователям
    banPosts: PropTypes.bool,

    // Запрет постить новым пользователям
    withLinks: PropTypes.bool
  };

  static contextTypes = {
    router: routerShape
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.onImageClick = this.onImageClick.bind(this);
    //this.onToggleImageListener = this.onToggleImageListener.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.closeDropDown = this.closeDropDown.bind(this);
    this.showApproveButton = this.showApproveButton.bind(this);
    this.votePlus = this.votePlus.bind(this);
    this.voteMinus = this.voteMinus.bind(this);
    this.replyAfterLogin = this.replyAfterLogin.bind(this);
    this.onResizeHandle = this.onResizeHandle.bind(this);
    this.onResize = this.onResizeHandle.bind(this);

    this.router = ctx.router;
    this.state = {
      highlighted: false,
      showPopup: false,
      needForumNick: false,
      showBottomPost: false,
      device: 'desktop',
      // heightMobileBlock: null,
    };
    this.post = null;
    this.clipboardCopy = null;
    this.images = {
      quoteImages: [],
      postImages: []
    };
    this.imageSource = 'postImages';
    this.selectedImageIndex = 0;
    this.scrollToPost = false;
  }

  componentDidMount() {
    if (this.post) this.post.addEventListener('click', this.onImageClick, false);
    this.onResizeHandle(this.sensor.getRuntime());

    if (
      get(this, 'props.router.location.hash') === `#post-${get(this, 'props.object.post_id')}`
    ){
      this.delay = setTimeout(
        () => this.scrollTo(this[`postRef-${get(this, 'props.object.post_id')}`]),
        1000);
      this.setState({ hash: get(this, 'props.router.location.hash') });
    }

    this.updateImg();
  }

  componentDidUpdate(prevProps) {
    const { auth = {} } = this.props;
    const { needForumNick, showBottomPost } = this.state;

    if (!auth.forum_nick && auth.forum_nick && showBottomPost) {
      this.replyAfterLogin()
    }

    if (auth.authenticated && !prevProps.auth.authenticated && needForumNick) {
      if (!auth.forum_nick) return this.setState({needForumNick: true, showBottomPost: false});
      this.setState({needForumNick: false, showBottomPost: true});
    }

    if (
      get(this, 'props.router.location.hash') !== this.state.hash &&
      get(this, 'props.router.location.hash') === `#post-${get(this, 'props.object.post_id')}`
    ){
      this.delay = setTimeout(
        () => this.scrollTo(this[`postRef-${get(this, 'props.object.post_id')}`]),
        1000
      );
      this.setState({ hash: get(this, 'props.router.location.hash') });
    }

    if (
      this.props.scrollToPostId !== prevProps.scrollToPostId
    ) {
      this.delay = setTimeout(
        () => this.scrollTo(this[`postRef-${this.props.scrollToPostId}`]),
        1000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.delay);
    if (this.post) {
      this.images = {
        quoteImages: [],
        postImages: []
      };
      this.imageSource = 'postImages';
      this.selectedImageIndex = 0;
      this.post.removeEventListener('click', this.onImageClick, false);
    }
  }

  onResizeHandle({ media: { desktop, tablet, phone } = {} }) {
    clearTimeout(this.delay);
    let device;
    if (desktop) {
      device = 'desktop';
    } else if (tablet) {
      device = 'tablet';
    } else if (phone) {
      device = 'phone';
    }

    if (device !== this.state.device) {
      this.setState({ device });
    }

    // if (device !== 'phone' && this.state.heightMobileBlock) {
    //   this.setState({ heightMobileBlock: null })
    // }

    // if (this.heightMobileBlock && device === 'phone') {
    //   const rect = this.heightMobileBlock.getBoundingClientRect() || {};
    //   const { top, bottom } = rect;
    //   const heightMobileBlock = bottom - top;
    //
    //   if (this.state.heightMobileBlock !== heightMobileBlock){
    //     this.setState({heightMobileBlock})
    //   }
    // }
  }

  scrollTo(ref) {
    const headerHeight = getHeaderHeight.call(this);
    scrollToComponent(ref, { offset: -headerHeight, align: 'top', duration: 300, ease: 'linear' });
  }

  updateImg() {
    const imgGroup = [...this.post.querySelectorAll('img.postImg')];
    if (imgGroup.length) {
      const parent = document.createElement('div');
      parent.className = "attachesBlock";
      imgGroup.forEach(card => {
        parent.appendChild(card);
      });
      this.post.appendChild(parent);
    }
  }

  onToggleImageListener(remove = false) {
    if (remove) {
      return this.post.removeEventListener('click', this.onImageClick, false);
    }
    this.post.addEventListener('click', this.onImageClick, false);
  }

  onToggleImageListenerRemove =()=> {
    this.onToggleImageListener(true);
  }

  onImageClick(e) {
    this.getAllImages(e);
    if (e.target.tagName.toLowerCase() === 'img' && e.target.classList.contains('postImg')) {
      this.selectedImageIndex =
        findIndex(
          this.images[this.imageSource],
          img => (img.x === e.target.x && img.y === e.target.y)
        );
      if (this.selectedImageIndex < 0) this.selectedImageIndex = 0;

      // Replace our image size for posts with full size for carousel
      this.images[this.imageSource] = map(
        this.images[this.imageSource],
        (img) => {
          let src = img.src;
          if (src.indexOf('/images/orig/640x640/') >= 0) {
            src = src.replace(/640x640/g, 'full').replace(/\.jpg/g, '');
          }
          return {
            src,
            alt: img.alt || '',
            title: img.title
          };
        }
      );

      this.setState(
        { showPopup: true },
        () => noScroll()
      );
    }
  }

  /**
   * Refills arrays for post and quote images separately.
   * Also detects which carousel to show: with images from quote or from post (without quote)
   *
   * @param e event
   */
  getAllImages(e) {
    const blockQuote = this.post.getElementsByTagName('blockquote')[0] || null;
    if (e && blockQuote) {
      this.imageSource = 'quoteImages';
      this.images.quoteImages = blockQuote.getElementsByTagName('img');
      this.images.quoteImages = filter(this.images.quoteImages, it => it.classList.contains('postImg'));
    }
    if (blockQuote && !blockQuote.contains(e.target)) this.imageSource = 'postImages';

    this.images.postImages = this.post.getElementsByTagName('img');
    this.images.postImages = filter(this.images.postImages,
      it => (it.classList.contains('postImg') &&
        findIndex(this.images.quoteImages, img => (img.x === it.x && img.y === it.y)) < 0)
    );
  }

  // Give to post +1 like.
  votePlus(data) {
    const { i18n } = this;
    const { auth, auth: { authenticated } = {}, checkPermission } = this.props;
    const myScore = data.my_score;
    const postId = data.post_id;
    const forumId = data.forum_id;
    const topicId = data.topic_id;
    const userId = data.user_id;

    if (auth.id === userId) return Notification.warning(i18n('likeCannotYourself'));

    if (myScore > 0) return Notification.warning(i18n('likedAlreadyYou'));

    if (authenticated) {
      if (!checkPermission(Perms.FORUM_ADD_LIKE) && !checkPermission(Perms.FORUM_DELETE_ALL_LIKE)) {
        return Notification.warning(i18n('permissionYouNotVote'));
      }

      this.api.post('action/forum/actions-set-vote/like', {
        postData: {
          postId,
          forumId,
          topicId,
          userId
        }
      })
        .then(() => { Notification.success(i18n('like')); emit('updateClubPosts'); })
        .catch(error => reportError(error));
    } else {
      // Show LogIn form.
      this.props.actionDoLogin();
    }
  }

  // Give to post -1 like.
  voteMinus(data) {
    const { i18n } = this;
    const { auth, auth: { authenticated } = {}, checkPermission } = this.props;
    const myScore = data.my_score;
    const postId = data.post_id;
    const forumId = data.forum_id;
    const topicId = data.topic_id;
    const userId = data.user_id;

    if (auth.id === userId) return Notification.warning(i18n('dislikeCannotYourself'));

    if (myScore < 0) return Notification.warning(i18n('dislikeAlreadyYou'));

    if (authenticated) {
      if (!checkPermission(Perms.FORUM_ADD_LIKE) && !checkPermission(Perms.FORUM_DELETE_ALL_LIKE)) {
        return Notification.warning(i18n('permissionYouNotVote'));
      }

      this.api.post('action/forum/actions-set-vote/dislike', {
        postData: {
          postId,
          forumId,
          topicId,
          userId
        }
      })
        .then(() => { Notification.success(i18n('dislike')); emit('updateClubPosts'); })
        .catch(error => reportError(error));
    } else {
      // Show LogIn form.
      this.props.actionDoLogin();
    }
  }

  copyToClipboard() {
    if (this.clipboardCopy) {
      let domain = '';
      let pathname = '';
      let value = null;
      if (__CLIENT__) {
        domain = window.location.origin;
        pathname = this.router.location.pathname;
        value = `${domain}${pathname}#post-${this.props.object.post_id}`;
      }

      if (value) this.clipboardCopy.copy(value, this.closeDropDown);
    }
  }

  closeDropDown() {
    if (this.ddRefMain) this.ddRefMain.getInstance().close();
    this.setState({ highlighted: true },
      () => setTimeout(() => this.setState({ highlighted: false }), 3000)
    );
  }

  postDropDown(isFirstPost) {
    const { i18n } = this;
    const { highlighted } = this.state;
    const {
      className, object: data = {}, complaintAdministration,
      auth = {}, checkPermission
    } = this.props;
    const isEditTopic = isFirstPost &&
      (data.showEditButton || checkPermission(Perms.FORUM_EDIT_ALL_TOPIC))
    const pageUrl = get(this, 'props.params.url');

    return (
      <DropDown
        {...bemClassesDDList({ extra: className })}
        ref={ref => this.ddRefMain = ref}
        modalHeader={i18n('menuPost')}
        modalCommonProps={{
          className: 'modalMorePost'
        }}
        alwaysDD
        inForm
        wAuto
        list
      >
        <Button
          {...bemClassesDDList('btn', { more: true, highlighted })}
          iconType={iconTypes.moreVertical}
          iconOnly
        />
        <div {...bemClassesDDList('contentContainer')}>
          <div {...bemClassesDDList('content')}>
            {!complaintAdministration &&
              <Button
                onClick={this.copyToClipboard}
                // iconType={iconTypes.copyLink}
                title={i18n('linkToPost')}
                label={i18n('linkToPost')}
                inListDD
              />
            }
            {/*!complaintAdministration && auth.authenticated &&
              <Share inListDD />
            */}
            {!complaintAdministration &&
            auth.authenticated &&
            checkPermission(Perms.FORUM_ADD_COMPLAINT) &&
              <Complaint
                entity="publication"
                entityId={+data.post_id}
                closeDropDown={this.closeDropDown}
                updateEvent="updatePosts"
                url={`${pageUrl}#post-${data.post_id}`}
                withIcon={false}
                inListDD
              />
            }
            {auth.authenticated && data.showEditButton && !isFirstPost &&
              <>
                {this.renderBtnEdit()}
                <Button
                  onClick={this.deletePost}
                  label={i18n('replyDeletePost')}
                  title={i18n('replyDeletePost')}
                  inListDD
                />
              </>
            }
            {isEditTopic &&
              <ForumTopicAdd
                forum_id={data.forum_id}
                topic_id={data.topic_id}
                router={this.props.router}
                auth={auth}
                checkPermission={checkPermission}
                modalBtnProps={{
                  label: i18n('changeTopicPolls'),
                  title: i18n('changeTopicPolls'),
                  inListDD: true
                }}
                modalSize="content"
                modalHeaderTitle={i18n('changeTopicPolls')}
              />
            }
            {isEditTopic &&
              <ModalButton
                buttonProps={{
                  label: i18n('topicDeletePost'),
                  title: i18n('topicDeletePost'),
                  inListDD: true
                }}
                classNameModal={bemClassesAdminPane('modal', 'remove').className}
                size="big"
              >
                <Header closeButton children={i18n('topicsDelete')} />
                <Content adaptiveHeight>
                  <div {...classesBemForm()}>
                    <RemoveThemeContent
                      listBoxItems={[{ id: data.topic_id, title: data.topic_title }]}
                      // onResetSelection={onResetSelection}
                      onDeletePost={this.goToForum}
                    />
                  </div>
                </Content>
              </ModalButton>
            }
          </div>
        </div>
      </DropDown>
    );
  }

  goToForum =()=> {
    const { object = {} } = this.props;

    if (object.forumUrl) this.props.router.push(object.forumUrl);
  }

  renderBtnEdit =(btnProps)=> {
    const { i18n } = this;
    const { object: data = {}, params, router } = this.props;

    return (
      <ModalButton
        ref={el => this.modalEditPost = el}
        buttonProps={{
          // iconType: iconTypes.edit,
          title: i18n('answerChangePost'),
          label: i18n('answerChangePost'),
          inListDD: true
        }}
        //onOpenCallback={this.onToggleImageListenerRemove}
        //onCloseCallback={this.onToggleImageListener}
        classNameModal={bemClassesAdminPane('modal', 'reply').className}
        size="big"
        {...btnProps}
      >
        <Header closeButton children={data.topic_title} />
        <Content adaptiveHeight>
          <div {...classesBemForm()}>
            <ReplyPostButton
              params={params}
              router={router}
              onPostSubmit={this.onPostSubmit}
              data={data}
              post_id={data.post_id}
              buttonTitle={i18n('answerChangePost')}
            />
          </div>
        </Content>
      </ModalButton>
    );
  }

  deletePost =()=> {
    const { object: data = {}, onHandleDeletePost } = this.props;
    onHandleDeletePost({ id: data.post_id })
  }

  // Show title for post for search page.
  /*
  TODO Веталь нужно удалить стили
  showTitle(item) {
    const { breadCrumbs = false, search = false } = this.props;
    const linkProps = {
      builder: linksForum.sectionForumTopics,
      builderProps: item
    };

    // If need show breadcrumbs then show title for post
    if (breadCrumbs) {
      return (
        <div {...bemClassesBlockForumList('search')}>
          {item.forum_title &&
            <Link
              {...bemClassesBlockForumList('link', 'topic')}
              {...linkProps}
            >
              <span {...bemClassesBlockForumList('linkContent')}>
                <span
                  {...bemClassesBlockForumList('text')}
                  dangerouslySetInnerHTML={{__html: item.forum_title}} // eslint-disable-line
                />
              </span>
            </Link>
          }
          {(item.forum_title && item.topic_title) &&
            <span {...bemClassesBlockForumList('text', 'separator')}>
              &nbsp;<Icon {...bemClassesBlockForumList('icon')} type={iconTypes.arrowRight} />&ensp;
            </span>
          }
          {item.topic_title && item.post_id &&
            <Button
              {...bemClassesBlockForumList('link', 'topic')}
              onClick={() => gotoLastPost.call(this, item.post_id)}
              title={item.topic_title}
              noPadding
              customRenderer
            >
              <span {...bemClassesBlockForumList('linkContent')}>
                <span
                  {...bemClassesBlockForumList('text')}
                  dangerouslySetInnerHTML={{__html: item.topic_title}} // eslint-disable-line
                />
              </span>
            </Button>
          }
        </div>
      );
    }

    // Show link go to post.
    if (!breadCrumbs && search) {
      return (
        <div {...bemClassesBlockForumList('search')}>
          <Button
            {...bemClassesBlockForumList('link', 'topic')}
            onClick={() => gotoLastPost.call(this, item.post_id)}
            title={item.topic_title}
            noPadding
            customRenderer
          >
            <span {...bemClassesBlockForumList('linkContent')}>
              <span {...bemClassesBlockForumList('text')} children="Перейти к посту" />
            </span>
          </Button>
        </div>
      );
    }
  }
  */

  // Define action after authorization
  replyAfterLogin(postId = null) {
    const { i18n } = this;
    const { userStatus = {}, data = {} } = this.props;

    // если передан id поста (только после авторизации) -
    // ожидаем перезагрузки данных поста и повторно вызываем экшн
    if (postId && postId === data.post_id) {
      return simpleStore.set('afterLoadAction', this.replyAfterLogin);
    }

    // если не админ, это тема клуба и юзер не участник клуба - вызов сообщения
    if (
      !userStatus.allRules &&
      (userStatus.forum_type === 'club' && !userStatus.clubUserStatus)
    ) {
      Notification.warning(i18n('answerClubMustMemberClub'));
    } else {
      //ответ в теме
      this.setState({
        needForumNick: false,
        showBottomPost: true
      })
    }
  }

  replyPost =()=> {
    const { auth, actionDoLogin, checkPermission, banPosts } = this.props;

    if (
      checkPermission(Perms.FORUM_PREMODERATION_POST) &&
      !checkPermission(Perms.FORUM_CONTROL_PREMODERATION_POST)  &&
      banPosts
    ) {
      return this.banPosts();
    }
    if (!auth.forum_nick) this.setState({
      needForumNick: true,
      showBottomPost: false
    });
    if (auth.forum_nick) this.setState({
      needForumNick: false,
      showBottomPost: true
    });
    if (!auth.authenticated && typeof actionDoLogin === 'function') return actionDoLogin();
  }

  closeReplyPost =()=> {
    this.setState({showBottomPost: false})
  }

  onCloseModalForumNick =()=> {
    this.setState({needForumNick: false});
  }

  showApproveButton(postId, postStatus) {
    const { i18n } = this;
    const { checkPermission } = this.props;
    const moderation = checkPermission(Perms.FORUM_CONTROL_PREMODERATION_POST);

    if (postStatus === 'unpublish' && moderation) {
      return (
        <Row {...bemClassesPosts('approve'/*, { grey: !moderation }*/)}>
          <Col allPr={0}>
            <span {...bemClassesPosts('text')} children={i18n('approvalPending')} />
          </Col>
          <Col allAuto allPr={0}>
            <ApprovePost postId={postId} />
          </Col>
        </Row>
      );
    }

    return null;
  }

  renderUserInfo() {
    const { device } = this.state;
    const { object, data } = this.props;
    const dataObj = object || data || {};

    return (
      <>
        {dataObj.user_id && dataObj.forum_nick &&
          <CardInfo
            {...bemClassesPostsUserInfo('cardInfo')}
            userPhoto={dataObj.avatar ? { id: dataObj.avatar } : null}
            userName={dataObj.forum_nick}
            userId={dataObj.user_id}
            userIsOp={dataObj.user_type === 'department'}
            dataObj={dataObj}
            device={device}
          />
        }
        {!dataObj.forum_nick &&
          <div className={`${bemClassesDD().className} ${bemClassesCardInfo('dd').className}`}>
            <div {...bemClassesCardInfo('btn', 'cardInfo', `${bemClassesBtn().className} ${bemClassesDD('btn').className} ${bemClassesPostsUserInfo('cardInfo').className}`)}>
              <span className={`${bemClassesBtn('content').className} ${bemClassesDD('btnContent').className}`}>
                <span className={`${bemClassesBtn('text').className} ${bemClassesDD('text').className}`} children="Anonymous" />
              </span>
            </div>
          </div>
        }
        {/*dataObj.user_id &&
          <div {...bemClassesPostsUserInfo('info')}>
            {dataObj.user_rank &&
              <span {...bemClassesPostsUserInfo('item', 'rank')}>
                <span {...bemClassesPostsUserInfo('text')}>{dataObj.user_rank.name}</span>
              </span>
            }
            <span {...bemClassesPostsUserInfo('item', 'rankExcept')}>
              <span {...bemClassesPostsUserInfo('item', 'replies')} title="Ответов">
                <span {...bemClassesPostsUserInfo('text', 'before')}>▪</span>
                <span {...bemClassesPostsUserInfo('text')}>Ответов: {dataObj.user_all_posts ? beautifyNumber(dataObj.user_all_posts) : 0}</span>
              </span>
              <span {...bemClassesPostsUserInfo('item', 'reputation')} title="Репутация">
                <span {...bemClassesPostsUserInfo('text', 'before')}>▪</span>
                <span {...bemClassesPostsUserInfo('text')}>Репутация: {beautifyNumber(dataObj.user_karma ? dataObj.user_karma : 0)}</span>
              </span>
              {!!dataObj.user_all_medals &&
                <span {...bemClassesPostsUserInfo('item', 'medals')} title="Награды">
                  <span {...bemClassesPostsUserInfo('text', 'before')}>▪</span>
                  <span {...bemClassesPostsUserInfo('text')}>Награды: {beautifyNumber(dataObj.user_all_medals)}</span>
                </span>
              }
            </span>
          </div>
        */}
      </>
    );
  };

  renderTime(data, lang) {
    return (
      <>
        <div {...bemClassesPosts('time')}>
          <span {...bemClassesPosts('text')}>
            {formatDate({
              date: data.post_time,
              format: 'dd mmm yyyy HH:MM'
            }, lang)}
          </span>
        </div>
      </>
    );
  }

  renderVoting(data) {
    const { i18n } = this;
    const { userStatus = {} } = this.props;

    if (!!userStatus.forum_type) return (
      <div {...bemClassesPosts('voting')}>
        <Button
          {...bemClassesPosts('btn', { votingUp: true, colored: data.likes + data.dislikes >= 10 })}
          onClick={() => this.votePlus(data)}
          // title={i18n('commentBtnVotingTitle')}
          title={i18n('commentRate')}
          iconType={iconTypes.votingUp}
          label={beautifyNumber(data.likes) || 0}
          iconOnly
        />
        <Button
          {...bemClassesPosts('btn', { votingDown: true, colored: data.likes + data.dislikes <= -10 })}
          onClick={() => this.voteMinus(data)}
          // title={i18n('commentBtnVotingTitle')}
          title={i18n('commentRate')}
          iconType={iconTypes.votingDown}
          label={beautifyNumber(data.dislikes) || 0}
          iconOnly
        />
      </div>
    );

    return null;
  }

  renderBtnReply(data) {
    const { i18n } = this;
    const { needForumNick } = this.state;
    const { userStatus = {} } = this.props;

    return (
      <>
        {!!userStatus.forum_type && data.topicIsOpen &&
          <Button
            {...bemClassesPosts('btn', 'reply')}
            iconType={iconTypes.reply}
            title={i18n('reply')}
            onClick={this.replyPost}
            iconOnly={true}
          />
        }
        {needForumNick &&
          <AddForumNick
            onCloseModalForumNick={this.onCloseModalForumNick}
            functionIsLogin={this.replyAfterLogin}
          />
        }
      </>
    );
  }

  onPostSubmit =(scrollToPostId = null)=> {
    this.setState({ needForumNick: false, showBottomPost: false });
    if (this.modalEditPost) this.modalEditPost.closeModal();
    if (scrollToPostId && this.props.onPostSubmit) this.props.onPostSubmit(scrollToPostId);
  }

  renderQuotePost(data) {
    const { i18n } = this;
    const { showBottomPost } = this.state;
    const { userStatus = {}, params, router, checkPermission } = this.props;

    if (!!userStatus.forum_type && data.topicIsOpen && showBottomPost) {
      return (
        <div {...bemClassesPosts('quotePostContainer', { isAdmin: checkPermission(Perms.FORUM_EDIT_ALL_TOPIC) })}>
          <Button
            {...bemClassesPosts('btn', 'close')}
            iconType={iconTypes.clear}
            title={i18n('btnClose')}
            onClick={this.closeReplyPost}
            //iconOnly={true}
          />
          <ReplyPostButton
            {...bemClassesPosts('quotePost')}
            params={params}
            router={router}
            onPostSubmit={this.onPostSubmit}
            data={data}
            quote
          />
        </div>
      );
    }

    return null;
  }

  /*
  showEditPostBtn() {
    const { i18n } = this;

    return (
      <>
        //TODO: Дима, в дизайне есть какой-то "?" - пострелиз
        <Button
          {...bemClassesPosts('btn', 'ask')}
          // onClick={this.}
          // iconType={iconTypes.clear}
          label="?"
          title="?"
        />
        {this.renderBtnEdit({
          ...bemClassesPosts('btn', 'edit'),
          buttonProps: {
            title: i18n('answerChangePost'),
            label: i18n('editPost')
          }
        })}
        <Button
          {...bemClassesPosts('btn', 'del')}
          onClick={this.deletePost}
          iconType={iconTypes.clear}
          title={i18n('replyDeletePost')}
        />
      </>
    );
  }
  */

  renderLinks(data) {
    if (data.topic_title && data.topic_url) {
      return (
        <div {...bemClassesPosts('linksContainer')}>
          <Link
            {...bemClassesPosts('link', 'toTopic')}
            builder={linksForum.sectionTopic}
            builderProps={{
              ...data,
              title: data.topic_title,
              topicUrl: data.topic_url,
              noPage: true
            }}
            noRedirector
            blank
          >
            <span {...bemClassesPosts('linkContent')}>
              <span
                {...bemClassesPosts('text')}
                dangerouslySetInnerHTML={{ __html: data.topic_title }}
              />
            </span>
          </Link>
          <Button
            {...bemClassesPosts('link', 'toPost')}
            onClick={() => gotoPostById.call(this, data.post_id)}
            title={this.i18n('linkToPost')}
            iconType={iconTypes.copyLink}
          />
        </div>
      );
    }

    return null;
  }

  render() {
    const { i18n, i18nGetLang } = this;
    const lang = i18nGetLang();
    const { showPopup, device /* , heightMobileBlock */ } = this.state;
    const {
      className, object, checkPermission, complaintAdministration,
      onHandleDeletePost, onHandleSelectPost, selectedPosts,
      auth, number, isFirstPage, withLinks
    } = this.props;
    const data = object || { ...this.props.data };
    const postStatus = data.post_status === 'unpublish' ||
      (data.post_status === 'autofilter' && checkPermission(Perms.FORUM_CONTROL_AUTOFILTER));
    // const showEditPostBtn = !checkPermission(Perms.FORUM_EDIT_ALL_TOPIC) && auth.authenticated && data.showEditButton;
    const page = +get(this, 'props.params.page');
    const isUserOfficial = get(data, 'user_official_account');
    const isFirstPost = number === 0 && isFirstPage;
    const images = get(data, 'attachments') || [];
    const isDesktop = device === 'desktop';
    const breakpointDesktop = (this.sensor.getVariable('breakpointDesktop') || 1250) - 1;
    const breakpointTablet = (this.sensor.getVariable('breakpointTablet') | 768) - 1;
    // const mobileBlockProps = {};
    const imgAttaches = map(images, (item, key) => {
      const alt = formatDate({ date: item.date, format: 'dd.mm.yyyy' }) || '';
      const title = item.comment;
      const image = get(item, 'id');
      const topic = title ? <div {...bemClassesPosts('text', 'topicFullScreen')} children={title} /> : null;

      return (
        <div {...bemClassesPosts('imgContainer')} key={key}>
          <div {...bemClassesPosts('img')}>
            <Image
              {...bemClassesPosts('imgPic')}
              image={{...getImages.call(this, item, { alt, title }).titleImage, topic}}
              group={`post${data.post_id}`}
            />
            <JsonLd
              item={{
                '@context': 'https://schema.org',
                '@type': 'ImageObject',
                name: alt || null,
                description: title || null,
                contentUrl: image ? absoluteUrl(`/images/thumb/full/${image}`) : null
              }}
            />
          </div>
          {!!topic && topic}
        </div>
      );
    });

    // if (heightMobileBlock) {
    //   mobileBlockProps.style = {
    //     minHeight: heightMobileBlock
    //   }
    // }

    return (
      <div
        {...bemClassesPosts({
          modifiers: { post: true, approve: postStatus, withAva: (!isDesktop && isUserOfficial) },
          extra: className
        })}
        ref={el => this[`postRef-${data.post_id}`] = el}
      >
        <ClipboardCopy
          ref={el => this.clipboardCopy = el}
          successMessage={i18n('linkPostCopiedClipboard')}
        />
        <div {...bemClassesPosts('content')}>
          {(!isDesktop && isUserOfficial) &&
            <div {...bemClassesPosts('avaContainer')}>
              <div {...bemClassesPosts('imgContainer')}>
                <div {...bemClassesPosts('img')}>
                  {data.avatar ?
                    <Thumb
                      {...bemClassesPosts('imgPic')}
                      image={{ id: data.avatar }}
                    /> :
                    <Icon {...bemClassesPosts('icon')} type={iconTypes.personCircle} />
                  }
                </div>
              </div>
            </div>
          }
          {isDesktop && this.renderUserInfo()}
          <Row {...bemClassesPosts('row', 'top')}>
            {!isDesktop &&
              <Col {...bemClassesPosts('col', 'user')} allAuto allPr={0}>
                {this.renderUserInfo()}
              </Col>
            }
            <Col {...bemClassesPosts('col', 'time')} allPr={0}>
              {this.renderTime(data, lang)}
            </Col>
            <Col {...bemClassesPosts('col', 'dd')} allAuto allPr={0}>
              {this.postDropDown(isFirstPost)}
            </Col>
          </Row>
          <div
            {...bemClassesPosts('main')}
            // {...mobileBlockProps}
          >
            <div
              {...bemClassesPosts('mainText')}
              // ref={el => this.heightMobileBlock = el}
            >
              <div
                ref={el => this.post = el}
                {...bemClassesPosts('text')}
                dangerouslySetInnerHTML={{ __html: data.post_text }}
              />
            </div>
            {!!images.length &&
              <div {...bemClassesPosts('attachesBlock')}>
                {images.length === 1 && imgAttaches}
                {images.length > 1 &&
                  <SlickSlider
                    slidesToShow={3}
                    slidesToScroll={1}
                    responsive={[
                      {
                        breakpoint: breakpointDesktop,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll: 1
                        }
                      },
                      {
                        breakpoint: breakpointTablet,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1
                        }
                      }
                    ]}
                  >
                    {imgAttaches}
                  </SlickSlider>
                }
              </div>
            }
            <div {...bemClassesPosts('mainTextFloat')}>
              {this.renderVoting(data)}
              {this.renderBtnReply(data)}
            </div>
          </div>
        </div>
        {this.renderQuotePost(data)}
        {this.showApproveButton(data.post_id, data.post_status)/* кнопа Одобрить */}
        {withLinks && this.renderLinks(data)}
        {data.allRules &&
          <PostControl
            {...bemClassesPosts('postControl')}
            itemId={data.post_id}
            topicId={data.topic_id}
            data={data.controlData}
            post={data.post_text}
            userPostsCount={data.user_all_posts}
            onHandleSelect={onHandleSelectPost}
            onHandleDelete={onHandleDeletePost}
            editBtn={this.renderBtnEdit}
            selectedPosts={selectedPosts}
            checkPermission={checkPermission}
            complaintAdministration={complaintAdministration}
          />
        }
        {/*
        <div {...bemClassesPosts('old')}>
          {data.isOnline &&
            <span {...bemClassesPosts('online')} title="Онлайн" />
          }
          {this.showTitle(data)}
        </div>
        */}
        {showPopup &&
          <FullScreenSlider
            images={this.images[this.imageSource]}
            selectedImage={this.selectedImageIndex}
            onCloseCallback={() => {
              this.setState(
                { showPopup: false },
                () => noScroll()
              );
            }}
          />
        }
      </div>
    );
  }
}
